import type { NextPage } from 'next';
import { UserCourseSummaries } from './Assignments/UserCourseSummaries';
import { PageTitle } from '~/pages/_shared';
import { useLocalization } from '~/framework';
import { ActiveNavItem } from '~/page-components/Layout';

const Courses: NextPage = () => {
   const { _js } = useLocalization();
   return (
      <>
         <PageTitle>{_js('Your Assigned Courses')}</PageTitle>
         <ActiveNavItem value="courses" />
         <UserCourseSummaries />
      </>
   );
};

export default Courses;
